var modules_2e027b98 = {"fullWidth":"OfferParam_module_fullWidth__78374e5e","nobreak":"OfferParam_module_nobreak__78374e5e"};
import "../../../../assets/esm/components/OfferCard/components/OfferParam/OfferParam~B0cVj4To.css";

export { modules_2e027b98 as default };
//# sourceMappingURL=OfferParam.module.scss.js.map
